import { render, staticRenderFns } from "./projectsTransfers.vue?vue&type=template&id=1ee5b536&"
import script from "./projectsTransfers.vue?vue&type=script&lang=js&"
export * from "./projectsTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports